<template>
    <section>
        <div class="container">
            <b-table
                v-if="!loading"
                class="table is-striped is-hoverable"
                :data="platforms"
                :columns="fields"
                ref="table"
                :paginated="isPaginated"
                :per-page="perPage"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :default-sort-direction="defaultSortDirection"
                :pagination-rounded="isPaginationRounded"
                :sort-icon="sortIcon"
                :sort-icon-size="sortIconSize"
                default-sort="name"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page">
            </b-table>
        </div>
    </section>
</template>
<script>
import axios from "axios";
export default {
	data() {
		return {
			platforms: [],
			fields: [],
			isPaginated: true,
			isPaginationSimple: false,
			isPaginationRounded: false,
			paginationPosition: 'bottom',
			defaultSortDirection: 'asc',
			sortIcon: 'arrow-up',
			sortIconSize: 'is-small',
			currentPage: 1,
			perPage: 20
    };
  },
  mounted() {
      const options = {
          method: 'GET',
          withCredentials: true,
          headers: {
              'Authorization': 'Bearer ' + this.$store.state.token
          },
          timeout: 1000
      };
      const url = "https://gamedb-backend.herokuapp.com/platforms";
    axios.interceptors.request.use(request => {
        return request
    });
    axios
      .get(url, options)
      .then(response => {
        this.platforms = response.data;
        this.fields = [
			{ field: 'name', label: 'Platform' }
		];
      })
      .catch(err => {
        console.log(err);
      });
      axios.interceptors.response.use(response => {
          return response
      });
  }
};
</script>
